















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Radio, { IOption } from '@/componentsV2/atoms/Radio/Radio.vue';

export interface IRadioGroup {
  options: IOption[];
  name: string;
}

@Component({
  components: {
    Radio
  }
})
export default class RadioGroup extends Vue {
  @Prop({ default: [] }) options!: IOption[];
  @Prop({ required: true }) name!: string;
  @Prop() initselectedOption!: any;

  selectedOption: any = '';

  @Watch('selectedOption')
  changeOption() {
    this.$emit('changeSelectedOption', this.selectedOption);
  }

  @Watch('initselectedOption')
  changeOptionInit() {
    this.selectedOption = this.initselectedOption;
  }

  handleClick(value: string) {
    this.selectedOption = value;
    this.$emit('click', value);
  }

  mounted() {
    this.selectedOption = this.initselectedOption;
  }
}
